import { type FC, type HTMLAttributes, type ReactNode } from "react";
import * as Card from "@wbly/ui/components/Card";
import { Button } from "@wbly/ui/components/Button";
import type { KeyTextField } from "@prismicio/client";
import styles from "./ContentCard.module.css";

export type ContentCardProps = {
  id: string;
  text: KeyTextField;
  discountCode?: KeyTextField;
  copyCodeButton?: ReactNode;
  ctaLinkedDoc?: string;
  ctaUrl?: KeyTextField;
  ctaText?: KeyTextField;
  theme: string;
} & HTMLAttributes<HTMLElement>;

const { root, promoText, footer, button } = styles;

export const ContentCard: FC<ContentCardProps> = (props) => {
  const {
    id,
    text,
    copyCodeButton,
    ctaLinkedDoc,
    ctaUrl,
    ctaText,
    discountCode,
    theme,
  } = props;

  return (
    <Card.Root
      id={id}
      className={root}
      data-palette={`${theme} fill`}
      data-marketing="content-card"
      as="div"
    >
      <Card.Content className={promoText}>{text && <p>{text}</p>}</Card.Content>
      {(discountCode || ctaText) && (
        <Card.Footer className={footer}>
          {discountCode ? (
            copyCodeButton
          ) : (
            <Button
              className={button}
              as="a"
              href={ctaLinkedDoc ? ctaLinkedDoc : ctaUrl}
              fullWidth={true}
            >
              {ctaText}
            </Button>
          )}
        </Card.Footer>
      )}
    </Card.Root>
  );
};

export default ContentCard;
